import React from 'react';
import classNames from 'classnames';

import TabNavigationItem from './TabNavigationItem';
import { TabNavigationItemFields, TabNavigationItemType } from './tabNavigationSpotTypes';

type DesktopTabNavigationProps = {
  navigationType: TabNavigationItemType;
  tabs?: TabNavigationItemFields[];
  activeIndex: number | null;
  handleTabClick: (index: number) => void;
  isFullWidth?: boolean;
  instanceId?: number;
  ariaLabel?: string;
};

const DesktopTabNavigation: React.FC<DesktopTabNavigationProps> = ({
  navigationType,
  tabs,
  activeIndex,
  handleTabClick,
  isFullWidth,
  instanceId,
  ariaLabel,
}) => {
  return (
    <div className="hidden justify-center md:flex">
      <div
        className={classNames(
          'flex min-h-[72px] justify-evenly border-b bg-[var(--tab-bg-color)] text-[var(--tab-text-color)]',
          isFullWidth ? 'w-full justify-between gap-x-0' : 'gap-x-4',
          navigationType === 'image' ? 'rounded-3xl' : 'rounded-full'
        )}
        role="tablist"
        aria-label={ariaLabel}
        aria-orientation="horizontal"
      >
        {tabs?.map((tab, index) => (
          <TabNavigationItem
            key={`tab-${tab.id}`}
            tab={tab}
            index={index}
            navigationType={navigationType}
            activeIndex={activeIndex}
            handleTabClick={handleTabClick}
            instanceId={instanceId}
          />
        ))}
      </div>
    </div>
  );
};

export default DesktopTabNavigation;
